import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import SalesTargetSalesChart from '../components/SalesTargetSalesChart';
import CustomerProductSection from '../components/CustomerProductSection';
import StatsCardsandBanner from '../components/StatsCardsandBanner';

const DashboardPage = () => {
  const navigate = useNavigate();

  

  return (
    <div className="md:p-10 p-6 text-base gap-4">
      <h1 className="text-2xl font-bold mb-4 dark:text-gray-200">Dashboard</h1>
      <p className="text-gray-600 pb-6 dark:text-gray-400">Dashboard</p>
        <div className="w-full flex-1 flex flex-wrap flex-col md:flex-row gap-4 pb-6">
          <div className="flex flex-row w-full flex-wrap gap-6 ">
            <div className="flex flex-col w-full lg:w-[49%] "><SalesTargetSalesChart /></div>
            <div className="flex flex-col w-full lg:w-[48%] "><StatsCardsandBanner /></div>
          </div>
            <div className="flex flex-wrap basis-[100%]"><CustomerProductSection /></div>
        </div>
    </div>
  );
};

export default DashboardPage;
